<template>
  <button type="button" :class="[toggled ? 'btn-warning' : 'btn-primary', 'mobile-toggle-button', 'btn', 'btn-block', 'btn-lg']" @click.prevent="onClicked">
    <div class="mobile-toggle-checkbox"><i :class="['far', toggled ? 'fa-check-square' : 'fa-square']" /></div><slot />
  </button>
</template>

<style scoped>
.mobile-toggle-button {
  position: relative;
}
.mobile-toggle-checkbox {
  position: absolute;
  left: 10px;
}
</style>

<script>
export default {
  name: 'MobileToggleButton',
  model: {
    event: 'change'
  },
  props: {
    value: Boolean
  },
  data() {
    return {
      toggled: this.$props.value ? true : false
    }
  },
  watch: {
    value: function(newVal) {
      this.toggled = this.$props.value ? true : false
    }
  },
  methods: {
    onClicked() {
      this.toggled = !this.toggled
      this.$emit('change', this.toggled)
    }
  }

}
</script>